import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";
import GetCustomersData from "../../Comman/GetCustomersData";
import GetSoldItesmData from "../../Comman/GetSoldItesmData";
import GetEarnings from "../../Comman/GetEarnings";
import GetItemData from "../../Comman/GetItemData";
import { AddCustomer, AddItem } from "../..";
import EditProformaInvoiceDataInFirebase from "./EditProformaInvoiceDataInFirebase";
import GetAssignerUserProformaInvoiceDataInFirebase from "../AssignerUser/ProformaInvoice/GetAssignerUserProformaInvoiceDataInFirebase";

const GetProformaInvoiceDataFirebase = async (state, dispatch, sharedBusinesses = null, allCustomers = null) => {
    if (!state?.USERID) return null;

    try {
        const userRef = ref(database, `invoiceGenerator/users/${state?.USERID}/proforma`);
        let snapshot = await get(userRef);
        let data = snapshot.val();
        let activeInvoices = data
            ? Object.entries(data).filter(([, invoice]) => !invoice?.isDeleted)
            : [];

        let currentItems = [];

        // Ensure customers are fetched even if no personal invoices exist
        const customersToUse = allCustomers || await GetCustomersData(state, dispatch, sharedBusinesses);

        if (activeInvoices.length > 0) {
            GetEarnings(state, dispatch, activeInvoices);
            currentItems = await GetItemData(state, dispatch, activeInvoices);

            const invoicesWithoutCustomer = activeInvoices.filter(([id, invoice]) => !invoice.customerId);

            if (invoicesWithoutCustomer.length > 0) {
                for (const [id, invoice] of invoicesWithoutCustomer) {
                    let matchedCustomer = customersToUse?.find(
                        (cust) => cust?.customer?.toLowerCase()?.trim() === invoice?.customer?.toLowerCase()?.trim()
                    );

                    let customerId;
                    if (!matchedCustomer) {
                        customerId = Date.now().toString();
                        const newCustomer = {
                            companyId: invoice?.companyId || "",
                            customer: invoice?.customer || "Unnamed Customer",
                            customerId,
                            createdAt: Date.now().toString(),
                            updatedAt: Date.now().toString(),
                            phone: invoice?.phone || "",
                            email: invoice?.email || "",
                            address: invoice?.address || "",
                            customerGSTNo: invoice?.customerGSTNo || "",
                            invoiceCount: "1",
                            invoices: [invoice?.invoiceId],
                            totalPaid: "0",
                        };
                        AddCustomer(state, dispatch, newCustomer);
                    } else {
                        customerId = matchedCustomer?.customerId;
                    }

                    const processedItems = (invoice?.items || []).map((item, index) => {
                        const matchedItem = currentItems?.find(
                            (existingItem) => existingItem?.name?.toLowerCase()?.trim() === item?.name?.toLowerCase()?.trim()
                        );
                        return {
                            ...item,
                            itemId: matchedItem?.itemId || `${Date.now()}${index}${invoice?.invoiceId?.toString().slice(0, 4)}`,
                        };
                    });

                    const invoiceData = { ...invoice, invoiceId: id, customerId, items: processedItems };
                    const newItemsToCreate = processedItems.filter(item => !currentItems?.some(existing => existing.itemId === item.itemId));
                    if (newItemsToCreate.length > 0) await AddItem(state, dispatch, newItemsToCreate);
                    await EditProformaInvoiceDataInFirebase(state, dispatch, id, invoiceData);
                }
                snapshot = await get(userRef);
                data = snapshot.val();
                activeInvoices = data
                    ? Object.entries(data).filter(([, invoice]) => !invoice?.isDeleted)
                    : [];
            }
        }

        const formattedData = activeInvoices.map(([uniqueID, info]) => ({
            uniqueID,
            ...info,
            isShared: false
        }));

        const sortedInvoiceData = formattedData
            .sort((a, b) => new Date(parseInt(b.date)) - new Date(parseInt(a.date)))
            .map((item, index) => ({ srNo: index + 1, ...item }));

        let finalProformaInvoices = sortedInvoiceData;

        /* -------- FETCH SHARED PROFORMA INVOICES -------- */

        const businessesToUse = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];

        if (businessesToUse.length) {

            const sharedInvoices = await GetAssignerUserProformaInvoiceDataInFirebase(
                state,
                dispatch,
                businessesToUse
            );

            finalProformaInvoices = [
                ...sortedInvoiceData,
                ...sharedInvoices
            ];
        }

        const invoiceIdMap = new Map();
        finalProformaInvoices.forEach((inv) => {
            const key = inv.isShared ? `shared_${inv.uniqueID}` : `local_${inv.uniqueID}`;
            invoiceIdMap.set(key, inv);
        });
        finalProformaInvoices = Array.from(invoiceIdMap.values())
            .sort((a, b) => new Date(parseInt(b.date)) - new Date(parseInt(a.date)))
            .map((item, index) => ({ srNo: index + 1, ...item }));

        dispatch({ type: actionType.PROFORMAINVOICES, payload: finalProformaInvoices });
        return finalProformaInvoices;

    } catch (error) {
        console.error("Error fetching invoice data:", error);
        return null;
    }
};

export default GetProformaInvoiceDataFirebase;
